import React, { Component } from "react";
import createReactClass from "create-react-class";
import * as d3 from "d3";
import "./App.css";
import TrendChart from "../TrendChart/TrendChart";
import PartyVoteChart from "../PartyVote/PartyVoteChart";
import ElectoratePVChart from "../ElectoratePV/ElectoratePVChart";
import ElectorateCVChart from "../ElectorateCV/ElectorateCVChart";
import Electorates from "./electorates";
import pym from "pym.js";
import queryString from "query-string";
import md5 from "md5";

const electorate_dict = {};
Electorates.forEach(d => (electorate_dict[d.electorate] = ""));
const electorate_list = Object.keys(electorate_dict);

var List = createReactClass({
  render() {
    return (
      <ul>
        {this.props.items.map(item => (
          <ListItem
            key={item}
            item={item}
            onItemClick={this.props.onItemClick}
          />
        ))}
      </ul>
    );
  }
});

var ListItem = createReactClass({
  render() {
    return <li onClick={this._onClick}>{this.props.item}</li>;
  },
  _onClick() {
    this.props.onItemClick(this.props.item);
  }
});

class App extends Component {
  constructor(props) {
    super(props);

    this.showElectorateList = this.showElectorateList.bind(this);
    this.hideElectorateList = this.hideElectorateList.bind(this);
    this.selectElectorate = this.selectElectorate.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    let qs = null;
    if (String.prototype.trim) {
      qs = queryString.parse(window.location.search);
    }

    this.state = {
      viewPortWidth:
        d3
          .selectAll(".container")
          .node()
          .getBoundingClientRect().width - 20,
      viewPortHeight: 1200,
      electorate: (qs && qs.electorate) || "Auckland Central",
      searchText: "",
      electorateListVisible: false
    };
  }

  showElectorateList() {
    this.setState({ electorateListVisible: true });
  }

  hideElectorateList() {
    const _this = this;
    setTimeout(() => _this.setState({ electorateListVisible: false }), 300);
  }

  selectElectorate(electorate) {
    this.setState({
      electorate: electorate,
      electorateListVisible: false,
      searchText: ""
    });
  }

  handleInputChange(event) {
    this.setState({ searchText: event.target.value.toLowerCase() });
  }

  handleSelect(value) {
    this.setState({ searchText: "", electorate: value });
  }

  matchElectorateToTerm(result, value) {
    return (
      result.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
      result.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  componentDidMount() {
    this.pymChild = new pym.Child();
    this.pymChild.sendHeight();
    window.addEventListener("resize", this.pymChild.sendHeight, false);
  }

  render() {
    let styles = {
      item: {
        padding: "2px 6px",
        cursor: "default",
        zIndex: "9999",
        position: "relative"
      },
      highlightedItem: {
        color: "pink",
        background: "#333",
        padding: "2px 6px",
        cursor: "default"
      }
    };

    let electorate_names = electorate_list.filter(
      d =>
        this.state.searchText === "" ||
        d.toLowerCase().search(this.state.searchText.toLowerCase()) !== -1
    );

    let result = [];

    return (
      <div className="App">
        <p className="explainer">
          This is the New Zealand Herald election forecast model, built using
          data from all major polls released over the previous 12 months and
          election results since 1999.
        </p>

        <p className="explainer">
          Below, you will find forecasts for projected seats by party, party
          vote at national level and party vote by electorate. Once the
          candidate lists are finalised, we’ll be adding forecasts for the
          electorate seats.
        </p>

        <p className="explainer">
          The model provides a better measure of uncertainty than individual
          polls.{" "}
          <a
            href="http://www.nzherald.co.nz/politics/news/article.cfm?c_id=280&objectid=11912489"
            target="_blank"
          >
            Read more here
          </a>{" "}
          about how the model was built.
        </p>

        <h4 className="header">Projected seats</h4>

        <p className="projections">
          <span className="labour">Labour</span> is projected to gain 23 seats
          to end up with <span className="labour">55(&plusmn;3) seats</span>,{" "}
          <br /> with <span className="national">National</span>, projected to
          be at <span className="national">51 (&plusmn;2) seats</span>.
        </p>

        <p className="projections">
          To form a government, a party or coalition needs at least 61 out of
          120 seats, or to reach a confidence-and-supply agreement. At this
          stage neither National or Labour have a clear path to 61 without New
          Zealand First support or a comeback from the Greens. The total number
          of seats could increase if there is an overhang from a minor party
          winning an electorate seat.
        </p>

        <p className="projections">
          {" "}
          <span className="nzf">New Zealand First</span>, projected to win{" "}
          <span className="nzf">9 (&plusmn;3) seats</span>.
        </p>

        <p className="projections">
          The <span className="green">Greens</span> are projected to be at{" "}
          <span className="green">6 (lower estimate of 0) seats</span>.
        </p>


        <p className="projections">
          Maori Party and ACT are projected to get one each.
        </p>

        <p className="projections">
          The model is not currently able to predict for The Opportunities
          Party, polling at 2 percent in the latest poll.
        </p>

        <small className="note">
          *Figures in brackets indicate margin of error
        </small>

        <h4 className="header">Predicted party vote</h4>

        <p className="explainer">
          The predicted party vote for every party. Darker colour shows the best
          estimate, while the complete band shows the range of where a given
          party could land.
        </p>
        <PartyVoteChart width={this.state.viewPortWidth} height={400} />
        <TrendChart width={this.state.viewPortWidth} height={400} />

        <h4 className="header">
          Predicted party vote for {this.state.electorate}
        </h4>
        <p className="explainer">
          Predictions for party vote by electorate take into account the trends
          in previous elections and polling data.
        </p>
        <div className="select-electorate">
          <input
            onFocus={this.showElectorateList}
            onBlur={this.hideElectorateList}
            onChange={this.handleInputChange}
            value={this.state.searchText}
            placeholder="Search electorate.."
          />
          <div
            className={
              "electorate-list" +
              (this.state.electorateListVisible ? " is-visible" : "")
            }
          >
            <List
              items={electorate_names}
              onItemClick={this.selectElectorate}
            />
          </div>
        </div>
        <ElectoratePVChart
          width={this.state.viewPortWidth}
          height={400}
          electorate={this.state.electorate}
        />

        <h4 className="header">
          Predicted candidate vote for {this.state.electorate}
        </h4>
        <p className="explainer">
          Predictions for candidate vote by electorate take into account the
          trends in previous elections and polling data. These are hardest to
          predict because of tactical voting
        </p>
        <p className="explainer-em">These are least reliable predictions due to lack of local polling. Also, these forecasts are not same as polls.</p> 
        <div className="select-electorate">
          <input
            onFocus={this.showElectorateList}
            onBlur={this.hideElectorateList}
            onChange={this.handleInputChange}
            value={this.state.searchText}
            placeholder="Search electorate.."
          />
          <div
            className={
              "electorate-list" +
              (this.state.electorateListVisible ? " is-visible" : "")
            }
          >
            <List
              items={electorate_names}
              onItemClick={this.selectElectorate}
            />
          </div>
        </div>

        <ElectorateCVChart
          width={this.state.viewPortWidth}
          height={400}
          electorate={this.state.electorate}
        />

       <p className="explainer"> Originally the model predicted candidate vote in Epsom similarly to the other electorates - using previous candidate vote, party vote in the electorate and incumbency. Epsom only party adjustments for National and ACT, compared to other electorates due to lack of data. This produced results unlikely due to tactical voting.</p>


       <p className="explainer"> Now, in Epsom the candidate vote is predicted using split voting data for the Epsom electorate from the last three elections. It estimates how voters for each party will split their candidate vote. For example, only about 50% of Labour Party voters vote for the Labour candidate. This should better allow us to predict Epsom given its different voting patterns relative to the rest of the country.</p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js